import { Row, Col } from '@sravni/react-design-system/lib/Grid';
import type { ColProps, RowProps } from '@sravni/react-design-system/lib/Grid';
import {
    EmailInput,
    GetOTPButton,
    NameInput,
    PhoneInput,
    ServerErrorMessage,
    useBehaviourState,
} from '@sravni/react-silent-authentication-form';
import React, { useCallback } from 'react';

import cn from 'classnames';
import { SCREENS } from '../constants';
import type { AuthInlineFormProps } from '../types';
import styles from './AuthInlineForm.module.scss';
import { BeforeSlot, AfterSlot } from './Slots';

const DEFAULT_SPAN: ColProps['span'] = { mobile: 12, tablet: 4, desktop: 4 };

const DEFAULT_OFFSET: ColProps['offset'] = { mobile: 0, tablet: 8, desktop: 8 };

const DEFAULT_GUTTER: RowProps['gutter'] = [16, 16];

type Props = Pick<
    AuthInlineFormProps,
    'getOTPButtonProps' | 'children' | 'isEnabledEmailField' | 'isEnabledNameField'
> & {
    currentScreen: ValuesOf<typeof SCREENS>;
    setCurrentScreen: React.Dispatch<ValuesOf<typeof SCREENS>>;
};

export const AuthInlineFormFields = (props: Props) => {
    const {
        isEnabledNameField = false,
        isEnabledEmailField = true,
        getOTPButtonProps,
        children,
        currentScreen,
        setCurrentScreen,
    } = props;
    const { isLoading } = useBehaviourState();

    const handleGetOTPButtonClick = useCallback(
        (event) => {
            getOTPButtonProps?.onClick?.(event);
            setCurrentScreen(SCREENS.OTP);
        },
        [getOTPButtonProps, setCurrentScreen],
    );

    return (
        <>
            <BeforeSlot.Renderer childs={children} />
            <Row gutter={DEFAULT_GUTTER}>
                {isEnabledNameField && (
                    <Col span={DEFAULT_SPAN}>
                        <NameInput required />
                    </Col>
                )}
                {isEnabledEmailField && (
                    <Col span={DEFAULT_SPAN}>
                        <EmailInput required />
                    </Col>
                )}
                <Col span={DEFAULT_SPAN}>
                    <PhoneInput />
                </Col>
                <Col span={12} className={styles.serverErrorWrapper}>
                    {currentScreen === SCREENS.INITIAL && <ServerErrorMessage className={styles.serverError} />}
                </Col>
            </Row>
            <AfterSlot.Renderer childs={children} />
            <Row gutter={DEFAULT_GUTTER}>
                <Col span={DEFAULT_SPAN} offset={DEFAULT_OFFSET}>
                    <GetOTPButton
                        {...getOTPButtonProps}
                        onClick={handleGetOTPButtonClick}
                        loading={isLoading && currentScreen === SCREENS.INITIAL}
                        size={52}
                        className={cn(styles.getOTPButton, getOTPButtonProps?.className)}
                    />
                </Col>
            </Row>
        </>
    );
};
